import {AfterViewInit, booleanAttribute, Directive, ElementRef, Input, NgZone, OnDestroy} from "@angular/core";
import {MatTooltip} from "@angular/material/tooltip";
import {CommonLayout} from "framework/ui/layout";
import {RafCoordinator} from "framework/ui/shared/raf-coordinator";
import {Subscription} from "rxjs";

@Directive({
               selector  : "[matTooltip][csTooltipWhenTruncated]",
               standalone: true
           })
export class TooltipWhenTruncatedDirective implements AfterViewInit,
                                                      OnDestroy
{
    private static readonly RAF_COORDINATOR = new RafCoordinator();

    private m_layoutSubscription: Subscription;
    private m_tooltipValue: string;

    @Input({
               transform: booleanAttribute,
               alias    : "csTooltipWhenTruncated"
           }) enabled: boolean;

    @Input() set csTooltipWhenTruncatedTooltip(tooltip: string)
    {
        tooltip ||= "";
        if (this.m_tooltipValue !== tooltip)
        {
            this.m_tooltipValue = tooltip;
            this.scheduleUpdate();
        }
    }

    @Input() csTooltipWhenTruncatedTarget: HTMLElement | ElementRef<HTMLElement> | null;

    constructor(private element: ElementRef,
                private tooltip: MatTooltip,
                private layout: CommonLayout,
                private zone: NgZone)
    {
        this.m_layoutSubscription = this.layout.contentSizeChanged.subscribe(() => this.scheduleUpdate());
    }

    ngAfterViewInit()
    {
        this.scheduleUpdate();
    }

    public ngOnDestroy(): void
    {
        TooltipWhenTruncatedDirective.RAF_COORDINATOR.cancel(this);
        this.m_layoutSubscription.unsubscribe();
        this.m_layoutSubscription = null;
    }

    private scheduleUpdate()
    {
        TooltipWhenTruncatedDirective.RAF_COORDINATOR.schedule(this, () => this.updateTooltip(), this.zone);
    }

    private updateTooltip()
    {
        if (!this.enabled) return;

        const target        = this.csTooltipWhenTruncatedTarget;
        const element       = target instanceof ElementRef ? target.nativeElement : target || this.element.nativeElement;
        const shouldDisable = element.scrollWidth <= element.offsetWidth;
        if (this.tooltip.disabled === shouldDisable) return;

        this.tooltip.disabled = shouldDisable;
    }
}
